import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'react-datepicker/dist/react-datepicker.css';
import './resources/sass/index.css';

ReactDOM.render(<App/>, document.getElementById('root'));
